<template>
  <div class="protests" id="protests-section">
       <h3 class="content__title">{{content.data.protests.header}}</h3>
    <div class="protests__intro content__text">
      <span v-html="content.data.protests.content"></span>
      <br /><br />
      <span v-html="content.data.protests.content_1"></span>
      <br /><br />
       <span v-html="content.data.protests.content_2"></span>

    </div>

    <div class="protests__slider">
    <SliderProtests />
    </div>
  </div>
</template>

<script>
import SliderProtests from "../elements/SliderProtests";
export default {
  name: "Protests",
  components: {
    SliderProtests,
  },
   inject: ['content'],
};
</script>
